var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { State, namespace } from "vuex-class";
import { Auth, Layout, Dependencies } from '~/core/decorator';
import DataBox from '~/components/common/data-box.vue';
import DataForm from '~/components/common/data-form.vue';
import { PageService } from '~/utils/page.service';
import { MENU_CHANNEL } from "~/config/enum.config";
import NumberRange from '~/components/common/number-range.vue';
import WarehousingApply from '~/components/apply-component/warehousing-apply.vue';
import OutgoingApplication from '~/components/car-management/outgoing-application.vue';
import { CarManageService } from "~/services/domain-service/car-manage.service";
import ChangeInfo from '~/components/car-management/changeInfo.vue';
var CollectionExecutionModule = namespace("collection-execution");
var InventoryVehicle = /** @class */ (function (_super) {
    __extends(InventoryVehicle, _super);
    function InventoryVehicle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataForm = {
            principalId: "",
            batchNumber: "",
            mobileNo: "",
            personalName: "",
            overdueAmount: { min: "", max: "" },
            caseNumber: '',
            principalName: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            idCard: '',
            loanDate: [],
            applyRealName: '',
            applyTime: [],
            warehouseCarStatus: '',
            userName: '',
            garageName: '',
            deptName: ''
        };
        _this.carFrameNo = '';
        _this.dataSet = [];
        _this.dialog = {
            warehouseShow: false,
            checkoutShow: false,
            changeInfoShow: false
        };
        _this.selectionList = [];
        _this.rowData = {};
        return _this;
    }
    Object.defineProperty(InventoryVehicle.prototype, "userId", {
        get: function () {
            return this.userData.id;
        },
        enumerable: false,
        configurable: true
    });
    InventoryVehicle.prototype.refreshData = function () {
        var _this = this;
        this.carManageService.getAllWarehouseCar(this.paramsHandler(), this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        }, function (error) { });
    };
    InventoryVehicle.prototype.paramsHandler = function () {
        var params = __assign({}, this.dataForm);
        params.overdueAmountMax = this.dataForm.overdueAmount.max;
        params.overdueAmountMin = this.dataForm.overdueAmount.min;
        params.loanDateMin = this.$filter.dateRanageFormat(this.dataForm.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.dataForm.loanDate).end;
        params.applyTimeMin = this.dataForm.applyTime.length ? this.$filter.dateTimeFormat(this.dataForm.applyTime[0]) : '';
        params.applyTimeMax = this.dataForm.applyTime.length ? this.$filter.dateTimeFormat(this.dataForm.applyTime[1]) : '';
        delete params.overdueAmount;
        delete params.loanDate;
        delete params.applyTime;
        return params;
    };
    InventoryVehicle.prototype.created = function () {
        this.refreshData();
    };
    InventoryVehicle.prototype.onClickInGarage = function (row) {
        this.dialog.warehouseShow = true;
        this.rowData = row;
        this.carFrameNo = row.carFrameNo;
    };
    InventoryVehicle.prototype.onClickOutGarage = function (row) {
        this.rowData = row;
        this.dialog.checkoutShow = true;
    };
    /**
     * 进入查看执行页
     */
    InventoryVehicle.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Car_garage,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    InventoryVehicle.prototype.handleResetForm = function () {
        this.dataForm.overdueAmount = { min: "", max: "" };
    };
    InventoryVehicle.prototype.onClickChangeInfo = function () {
        if (!this.selectionList.length)
            return this.$message.error('请选择要变更的案件记录！');
        this.dialog.changeInfoShow = true;
    };
    __decorate([
        Dependencies(PageService)
    ], InventoryVehicle.prototype, "pageService", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], InventoryVehicle.prototype, "carManageService", void 0);
    __decorate([
        State
    ], InventoryVehicle.prototype, "principalList", void 0);
    __decorate([
        State
    ], InventoryVehicle.prototype, "userData", void 0);
    InventoryVehicle = __decorate([
        Auth(1533),
        Layout('workspace'),
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                NumberRange: NumberRange,
                WarehousingApply: WarehousingApply,
                OutgoingApplication: OutgoingApplication,
                ChangeInfo: ChangeInfo
            }
        })
    ], InventoryVehicle);
    return InventoryVehicle;
}(Vue));
export default InventoryVehicle;
